import { useQuery } from "@tanstack/react-query";
import { fetchAnnouncements } from "@/lib/apiData";
import { useSite } from "@/context/SiteContext";

export const AnnouncementBar = () => {
  const { t } = useSite();
  const { data: anns = [] } = useQuery({ queryKey: ["announcements"], queryFn: fetchAnnouncements });
  if (!anns.length) return null;

  const loop = [...anns, ...anns, ...anns];
  return (
    <div className="bg-[#d00000] text-white text-sm overflow-hidden" data-testid="announcement-bar">
      <div className="marquee py-2">
        {[0, 1].map((dup) => (
          <div className="marquee__track" key={dup} aria-hidden={dup === 1}>
            {loop.map((a, i) => (
              <span key={`${dup}-${i}`} className="whitespace-nowrap flex items-center gap-3">
                {t(a.message)}
                <span className="text-white/50">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
